import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '@/components/shared/Sidebar';
import { Home, Briefcase, Search, ClipboardList, BarChart3, Users, Settings, FileSpreadsheet, Coins, MessageSquare } from 'lucide-react';
import RecruiterHome from './RecruiterHome';
import RecruiterJobs from './RecruiterJobs';
import RecruiterSearch from './RecruiterSearch';
import RecruiterScreenings from './RecruiterScreenings';
import RecruiterAnalytics from './RecruiterAnalytics';
import RecruiterTeam from './RecruiterTeam';
import RecruiterSettings from './RecruiterSettings';
import RecruiterProfileSetup from './RecruiterProfileSetup';
import RecruiterJobDetail from './RecruiterJobDetail';
import RecruiterJourneyView from './RecruiterJourneyView';
import RecruiterInterviewReview from './RecruiterInterviewReview';
import RecruiterJobHistory from './RecruiterJobHistory';
import RecruiterOrgJobs from './RecruiterOrgJobs';
import RecruiterReports from './RecruiterReports';
import RecruiterWallet from './RecruiterWallet';
import RecruiterReviews from './RecruiterReviews';
import CandidateJourneyDetail from '@/components/shared/CandidateJourneyDetail';
import ContactUs from '@/pages/ContactUs';

const navItems = [
  { to: '/recruiter', icon: Home, label: 'Dashboard' },
  { to: '/recruiter/jobs', icon: Briefcase, label: 'Jobs' },
  { to: '/recruiter/org-jobs', icon: Briefcase, label: 'Org Jobs' },
  { to: '/recruiter/wallet', icon: Coins, label: 'Mu Points' },
  { to: '/recruiter/reports', icon: FileSpreadsheet, label: 'Reports' },
  { to: '/recruiter/search', icon: Search, label: 'AI Search' },
  { to: '/recruiter/analytics', icon: BarChart3, label: 'Analytics' },
  { to: '/recruiter/reviews', icon: MessageSquare, label: 'Reviews' },
  { to: '/recruiter/team', icon: Users, label: 'Team' },
  { to: '/recruiter/settings', icon: Settings, label: 'Settings' },
];

export default function RecruiterDashboard() {
  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-[#0a0a0b]" data-testid="recruiter-dashboard">
      <Sidebar items={navItems} title="Recruiter" />
      <main className="flex-1 overflow-auto pt-14 lg:pt-0">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
          <Routes>
            <Route index element={<RecruiterHome />} />
            <Route path="jobs" element={<RecruiterJobs />} />
            <Route path="jobs/history" element={<RecruiterJobHistory />} />
            <Route path="jobs/:jobId" element={<RecruiterJobDetail />} />
            <Route path="jobs/:jobId/journey" element={<RecruiterJourneyView />} />
            <Route path="jobs/:jobId/journey/:matchId" element={<CandidateJourneyDetail role="recruiter" />} />
            <Route path="jobs/:jobId/interviews" element={<RecruiterInterviewReview />} />
            <Route path="search" element={<RecruiterSearch />} />
            <Route path="screenings" element={<RecruiterScreenings />} />
            <Route path="analytics" element={<RecruiterAnalytics />} />
            <Route path="team" element={<RecruiterTeam />} />
            <Route path="org-jobs" element={<RecruiterOrgJobs />} />
            <Route path="reports" element={<RecruiterReports />} />
            <Route path="wallet" element={<RecruiterWallet />} />
            <Route path="reviews" element={<RecruiterReviews />} />
            <Route path="settings" element={<RecruiterSettings />} />
            <Route path="profile-setup" element={<RecruiterProfileSetup />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="contact/ticket/:ticketId" element={<ContactUs />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
